import { render, staticRenderFns } from "./LicenceTable.vue?vue&type=template&id=f9c0610e"
import script from "./LicenceTable.vue?vue&type=script&lang=js"
export * from "./LicenceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports